<script>

    export let label = ''
    export let value = ''
    export let prefix = ''
    export let postfix = ''
    export let icon = null
    export let link = null
    export let subtitle = null
    export let pointer = false

</script>

<small><b>{ label }</b></small>

<div on:click>

    {#if link}

        <a href="{ link }" target="_blank">

            {#if icon}
                <span class="icon"><i class="fas fa-{icon}"></i></span>
            {/if}

            { prefix } { value } {postfix}
        </a>

    {:else if icon}

        <span class="icon-text" class:pointer={pointer}>
            <span class="icon"><i class="fas fa-{icon}"></i></span>
            <span>{ prefix } { value } {postfix}</span>
        </span>

    {:else}

        <div class:pointer={pointer}>{ prefix } { value } {postfix}</div>

        {#if subtitle}
            <div class="subtitle is-6">{ subtitle }</div>
        {/if}

    {/if}
</div>